import * as React from "react";
const SvgPencil = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 64", fill: "currentColor", stroke: "none", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M12,44l-4,12l12,-4z m4,-4l8,8l24,-24l-8,-8z m28,-28l8,8l6,-6l-8,-8z" }));
export default SvgPencil;
